import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogClose } from '@angular/material/dialog';
import { ModalWindowComponent } from '../modal-window/modal-window.component';
import { MatIconButton, MatButton } from '@angular/material/button';
import { AriaLabelDirective } from 'src/app/shared/directives/aria-label.directive';
import { MatIcon } from '@angular/material/icon';
import { ADPComponentsModule } from 'digital-core';

@Component({
    selector: 'app-spoe-simple-error-dialog',
    templateUrl: './spoe-simple-error-dialog.component.html',
    styleUrls: ['./spoe-simple-error-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        ModalWindowComponent,
        MatIconButton,
        AriaLabelDirective,
        MatDialogClose,
        MatIcon,
        ADPComponentsModule,
        MatButton,
    ]
})
export class SpoeSimpleErrorDialogComponent {
  data = inject(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef<SpoeSimpleErrorDialogComponent>);

  constructor() {
    this.dialogRef.disableClose = false;
  }
}
